<template>
  <v-container fluid class="for-sale-vehicle-list">
    <div class="page-title">幸運車牌出售</div>
    <div class="page-desc">
      本公司持有大批幸運數字車牌號碼，已有大量成交記錄，誠信可靠，歡迎前往我們的店鋪任意挑選。
    </div>

    <!-- <div class="d-flex align-center mb-4">
      <v-btn color="primary" small :loading="loading" :disabled="loading" @click="load">
        <v-icon left>mdi-refresh</v-icon>
        刷新
      </v-btn>
      <v-spacer />
      <div v-if="lastUpdatedAt" class="text-caption grey--text">更新：{{ lastUpdatedAt }}</div>
    </div> -->

    <v-alert v-if="error" type="error" dense text class="mb-4">
      {{ error }}
    </v-alert>

    <div v-if="!loading && columns.length === 0" class="text-body-2 grey--text">暫無資料</div>

    <div class="plate-grid" v-else>
      <div v-for="(col, cIdx) in columns" :key="cIdx" class="plate-col">
        <div v-for="(plate, pIdx) in col" :key="`${cIdx}-${pIdx}-${plate}`" class="plate-cell">
          {{ plate }}
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import { getForSaleVehicleList } from '@/api/lpms';

export default {
  name: 'ForSaleVehicleList',
  data() {
    return {
      loading: false,
      error: '',
      columns: [],
      lastUpdatedAt: '',
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    normalizeColumns(raw) {
      // Expected shape: string[][]
      if (!Array.isArray(raw)) return [];

      return raw
        .filter(col => Array.isArray(col) && col.length > 0)
        .map(col =>
          col.filter(x => typeof x === 'string' && x.trim().length > 0).map(x => x.trim()),
        )
        .filter(col => col.length > 0);
    },
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const raw = await getForSaleVehicleList();
        this.columns = this.normalizeColumns(raw);
        this.lastUpdatedAt = dayjs().format('YYYY-MM-DD HH:mm');
      } catch (e) {
        // ApiError has a friendly message; fall back to stringification
        this.error = e?.message || String(e);
        this.columns = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.for-sale-vehicle-list {
  background: #fff;
}

.page-title {
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 8px 0 12px;
  color: #2c2c2c;
}

.page-desc {
  font-size: 18px;
  line-height: 1.6;
  color: #555;
  margin-bottom: 18px;
  max-width: 1100px;
}

.plate-grid {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  flex-wrap: wrap;
}

.plate-col {
  display: flex;
  flex-direction: column;
}

.plate-cell {
  min-width: 100px;
  padding: 10px 14px;
  background: #f6d46b;
  border: 1px solid rgba(0, 0, 0, 0.18);
  color: #1d1d1d;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 1px;
  user-select: text;
}
</style>
